import {
  CButton,
  CCardHeader,
  CCol,
  CInput,
  CLabel,
  CRow,
  CSpinner,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { apiCall, downloadUrl } from "src/_apiConfig/apiCall";
const PendingApprovalView = () => {
  let history = useHistory();

  let { userId } = useParams();
  const [viewApprovalDetails, setviewApprovalDetails] = useState();
  const [viewUserDocuments, setviewUserDocuments] = useState();
  const [transferLotDetails, setTransferLotDetails] = useState();

  const [showList, setshowList] = useState();

  const getApprovalDetails = async () => {
    const header = new Headers();
    // header.append("", "");
    setshowList(false);
    const response = await apiCall(
      `User/GetPendingApproval?$filter=userid eq ${userId}`,
      "GET",
      header,
      null
    );
    const jsonobj = await response.json();
    if (response.status === 200) {
      setviewApprovalDetails(jsonobj[0]);

      const responseTransferData = await apiCall(
        `LotTransfer?$filter=transferToUserId eq ${userId}`,
        "GET",
        header,
        null
      );
      const jsonobjTransferData = await responseTransferData.json();
      if (
        responseTransferData.status === 200 &&
        jsonobjTransferData.length > 0
      ) {
        setTransferLotDetails(jsonobjTransferData[0]);
      }
      setshowList(true);
    }
  };

  const getUserDocument = async () => {
    const header = new Headers();
    setshowList(false);
    const response = await apiCall(
      `User/GetUserDocument?userid=${userId}`,
      "GET",
      header,
      null
    );
    const jsonobj = await response.json();
    if (response.status === 200) {
      setviewUserDocuments(jsonobj);
    }
  };

  useEffect(() => {
    getApprovalDetails();
    getUserDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const approveUser = async () => {
    const header = new Headers();

    header.append("Content-Type", "application/json");
    const response = await apiCall(
      `User/ApproveUser?userId=${userId}`,
      "POST",
      header,
      JSON.stringify({
        userId: Number(userId),
      })
    );

    const jsonobj = await response.json();

    if (response.status === 200 && jsonobj !== -1 && jsonobj !== -2) {
      history.push("/requestlist/pendingapprovals");
    }
  };
  const rejectUser = async () => {
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      `User/RejectUser?userId=${userId}`,
      "POST",
      header,
      JSON.stringify({
        userId: Number(userId),
      })
    );

    const jsonobj = await response.json();

    if (response.status === 200 && jsonobj !== -1 && jsonobj !== -2) {
      console.log(transferLotDetails);
      const responseData = await apiCall(
        `LotTransfer/update`,
        "PUT",
        header,
        JSON.stringify({
          lotTransferId: Number(transferLotDetails.lotTransferId),
          lotId: Number(transferLotDetails.lotId),
          transferFromUserId: Number(transferLotDetails.transferFromUserId),
          transferToUserId: Number(transferLotDetails.transferToUserId),
          status: 2,
          approvedByUserId: null,
          comments: transferLotDetails.comments,
        })
      );
      const jsonobjData = await responseData.json();
      if (
        responseData.status === 200 &&
        jsonobjData !== -1 &&
        jsonobjData !== -2
      ) {
        history.push("/requestlist/pendingapprovals");
      }
    }
  };

  const textBoxShow = (lable, value, id = "exampleFormControlInput1") => {
    return (
      <CCol xl={4}>
        <CLabel htmlFor={id}>{lable}</CLabel>
        <CInput value={value === null ? " " : value} disabled id={id} />
      </CCol>
    );
  };

  return (
    <>
      {!showList ? (
        <CSpinner
          className="spinner-grow col-6 offset-6 mt-6"
          color="success"
        />
      ) : (
        <CCardHeader>
          <CRow className="pt-3" xl={12}>
            <CCol xl={10}>
              <h3>Approval Request Details</h3>
              <hr />
            </CCol>
          </CRow>

          <CRow className="mt-3">
            {console.log("viewApprovalDetails:", viewApprovalDetails)}
            {textBoxShow("Email Address : ", viewApprovalDetails?.emailId)}
            {textBoxShow("Mobile No. : ", viewApprovalDetails?.mobile)}
            {textBoxShow("Username : ", viewApprovalDetails?.username)}
            {textBoxShow("First Name : ", viewApprovalDetails?.firstName)}
            {textBoxShow("Last Name : ", viewApprovalDetails?.lastName)}
            {textBoxShow("House No : ", viewApprovalDetails?.houseNo)}
            {textBoxShow("Street Location : ", viewApprovalDetails?.streetName)}
            {textBoxShow("Area Landmark : ", viewApprovalDetails?.area)}
            {textBoxShow("Company City : ", viewApprovalDetails?.city)}
            {textBoxShow("District : ", viewApprovalDetails?.disctrict)}
            {textBoxShow("State Name : ", viewApprovalDetails?.state)}
            {textBoxShow("Pincode : ", viewApprovalDetails?.pincode)}
            {textBoxShow("Contact No 1 : ", viewApprovalDetails?.contact1)}
            {textBoxShow("Contact No 2 : ", viewApprovalDetails?.contact2)}
            {textBoxShow("Contact No 3 : ", viewApprovalDetails?.contact3)}
            {textBoxShow("Fax Number : ", viewApprovalDetails?.fax)}
            {textBoxShow("Alter Email : ", viewApprovalDetails?.alternateEmail)}
            {textBoxShow("Lot Details : ", viewApprovalDetails?.lotDetails)}
          </CRow>

          <CRow className="pt-3" xl={12}>
            <CCol xl={10}>
              <h3>Company Details</h3>
              <hr />
            </CCol>
          </CRow>
          <CRow className="mt-3">
            <CCol xl={4}>
              <CLabel> Company Name : </CLabel>
              {viewUserDocuments &&
                viewUserDocuments?.companyName &&
                viewUserDocuments.companyName !== "" &&
                viewUserDocuments.companyName}
              {/* {(viewUserDocuments !== undefined && viewUserDocuments != null && viewUserDocuments.companyName !== undefined && viewUserDocuments.companyName !== "" && viewUserDocuments.companyName !== null) ?
                (
                  (viewUserDocuments.companyName)
                )
                :
                ("")
                } */}
            </CCol>
            <CCol xl={4}>
              <CLabel> Company PAN : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.pan !== undefined
                ? viewUserDocuments.pan
                : ""}
            </CCol>
            <CCol xl={4}>
              <CLabel> Company Type : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.companyType !== undefined
                ? viewUserDocuments.companyType
                : ""}
            </CCol>
          </CRow>

          <CRow className="mt-3">
            <CCol xl={4}>
              <CLabel> Company Category : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.categoryName !== undefined
                ? viewUserDocuments.categoryName
                : ""}
            </CCol>
            <CCol xl={4}>
              <CLabel> Company Registred District : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.registeredDistrict !== undefined
                ? viewUserDocuments.registeredDistrict
                : ""}
            </CCol>
            <CCol xl={4}>
              <CLabel> Company GST : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.gst !== undefined
                ? viewUserDocuments.gst
                : ""}
            </CCol>
          </CRow>

          <CRow className="pt-3" xl={12}>
            <CCol xl={10}>
              <h3>Company Director</h3>
              <hr />
            </CCol>
          </CRow>
          <CRow className="mt-3">
            <CCol xl={4}>
              <CLabel> Director Name - 1 : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.directorName1 !== undefined
                ? viewUserDocuments.directorName1
                : ""}
            </CCol>
            <CCol xl={4}>
              <CLabel> Director Name - 2 : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.directorName2 !== undefined
                ? viewUserDocuments.directorName2
                : ""}
            </CCol>
            <CCol xl={4}>
              <CLabel> Director Name - 3 : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.directorName3 !== undefined
                ? viewUserDocuments.directorName3
                : ""}
            </CCol>
          </CRow>
          <CRow className="mt-3">
            <CCol xl={4}>
              <CLabel> Director Name - 4 : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.directorName4 !== undefined
                ? viewUserDocuments.directorName4
                : ""}
            </CCol>
            <CCol xl={4}>
              <CLabel> Director Name - 5 : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.directorName5 !== undefined
                ? viewUserDocuments.directorName5
                : ""}
            </CCol>
            <CCol xl={4}>
              <CLabel> Director Name - 6 : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.directorName6 !== undefined
                ? viewUserDocuments.directorName6
                : ""}
            </CCol>
          </CRow>
          <CRow className="mt-3">
            <CCol xl={4}>
              <CLabel> Director Name - 7 : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.directorName7 !== undefined
                ? viewUserDocuments.directorName7
                : ""}
            </CCol>
            <CCol xl={4}>
              <CLabel> Director Name - 8 : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.directorName8 !== undefined
                ? viewUserDocuments.directorName8
                : ""}
            </CCol>
            <CCol xl={4}>
              <CLabel> Director Name - 9 : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.directorName9 !== undefined
                ? viewUserDocuments.directorName9
                : ""}
            </CCol>
          </CRow>
          <CRow className="pt-3" xl={12}>
            <CCol xl={10}>
              <h3>Bank Details</h3>
              <hr />
            </CCol>
          </CRow>
          <CRow className="mt-3">
            <CCol xl={4}>
              <CLabel> Account Number : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.accountNumber !== undefined
                ? viewUserDocuments.accountNumber
                : ""}
            </CCol>
            <CCol xl={4}>
              <CLabel> Bank Account Type : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.bankAccountType !== undefined
                ? viewUserDocuments.bankAccountType
                : ""}
            </CCol>
          </CRow>
          <CRow className="mt-3">
            <CCol xl={4}>
              <CLabel> Bank Branch : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.bankBranch !== undefined
                ? viewUserDocuments.bankBranch
                : ""}
            </CCol>
            <CCol xl={4}>
              <CLabel> IFSC Code : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.ifscCode !== undefined
                ? viewUserDocuments.ifscCode
                : ""}
            </CCol>
            <CCol xl={4}></CCol>
          </CRow>
          <CRow className="pt-3" xl={12}>
            <CCol xl={10}>
              <h3>User Documents</h3>
              <hr />
            </CCol>
          </CRow>
          <CRow>
            <CCol xl={4}>
              <CLabel> Pan Card : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.pancardpath !== undefined &&
              viewUserDocuments.pancardpath !== "" &&
              viewUserDocuments.pancardpath !== null ? (
                <a
                  className="ml-2"
                  target="_blank"
                  href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.pancardpath}`}
                  rel="noreferrer"
                >
                  View
                </a>
              ) : (
                ""
              )}
            </CCol>
            <CCol xl={4}>
              <CLabel> Aadhar Card : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.aadharcardpath !== undefined &&
              viewUserDocuments.aadharcardpath !== "" &&
              viewUserDocuments.aadharcardpath !== null ? (
                <a
                  className="ml-2"
                  target="_blank"
                  href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.aadharcardpath}`}
                  rel="noreferrer"
                >
                  View
                </a>
              ) : (
                ""
              )}
            </CCol>
            <CCol xl={4}></CCol>
          </CRow>
          <CRow>
            <CCol xl={4}>
              <CLabel> ITR1 : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments != null &&
              viewUserDocuments.itr1path !== undefined &&
              viewUserDocuments.itr1path !== "" &&
              viewUserDocuments.itr1path !== null ? (
                <a
                  className="ml-2"
                  target="_blank"
                  href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.itr1path}`}
                  rel="noreferrer"
                >
                  View
                </a>
              ) : (
                ""
              )}
            </CCol>
            <CCol xl={4}>
              <CLabel> ITR2 : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments != null &&
              viewUserDocuments.itr2path !== undefined &&
              viewUserDocuments.itr2path !== "" &&
              viewUserDocuments.itr2path !== null ? (
                <a
                  className="ml-2"
                  target="_blank"
                  href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.itr2path}`}
                  rel="noreferrer"
                >
                  View
                </a>
              ) : (
                ""
              )}
            </CCol>
            <CCol xl={4}>
              <CLabel> ITR3 : </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.itr3path !== undefined &&
              viewUserDocuments.itr3path !== "" &&
              viewUserDocuments.itr3path !== null ? (
                <a
                  className="ml-2"
                  target="_blank"
                  href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.itr3path}`}
                  rel="noreferrer"
                >
                  View
                </a>
              ) : (
                ""
              )}
            </CCol>
          </CRow>
          <CRow>
            <CCol xl={4}>
              <CLabel> GSTIN Certificate: </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.gstincertificatepath !== undefined &&
              viewUserDocuments.gstincertificatepath !== "" &&
              viewUserDocuments.gstincertificatepath !== null ? (
                <a
                  className="ml-2"
                  target="_blank"
                  href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.gstincertificatepath}`}
                  rel="noreferrer"
                >
                  View
                </a>
              ) : (
                ""
              )}
            </CCol>
            <CCol xl={4}>
              <CLabel> DFO Registration Certificate: </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.dforegistrationcertificatepath !== undefined &&
              viewUserDocuments.dforegistrationcertificatepath !== "" &&
              viewUserDocuments.dforegistrationcertificatepath !== null ? (
                <a
                  className="ml-2"
                  target="_blank"
                  href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.dforegistrationcertificatepath}`}
                  rel="noreferrer"
                >
                  View
                </a>
              ) : (
                ""
              )}
            </CCol>
            <CCol xl={4}>
              <CLabel> Scanned copy of Partnership Firm: </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.scannedcopyofpartnershipfirmpath !==
                undefined &&
              viewUserDocuments.scannedcopyofpartnershipfirmpath !== "" &&
              viewUserDocuments.scannedcopyofpartnershipfirmpath !== null ? (
                <a
                  className="ml-2"
                  target="_blank"
                  href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.scannedcopyofpartnershipfirmpath}`}
                  rel="noreferrer"
                >
                  View
                </a>
              ) : (
                ""
              )}
            </CCol>
          </CRow>
          <CRow>
            <CCol xl={4}>
              <CLabel>
                {" "}
                Scanned copy of Certificate of Company Incorporation of Latest
                Directors of company, AOA and MOA :{" "}
              </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments !== null &&
              viewUserDocuments.moapath !== undefined &&
              viewUserDocuments.moapath !== "" &&
              viewUserDocuments.moapath !== null ? (
                <a
                  className="ml-2"
                  target="_blank"
                  href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.moapath}`}
                  rel="noreferrer"
                >
                  View
                </a>
              ) : (
                ""
              )}
            </CCol>
            <CCol xl={4}>
              <CLabel>
                {" "}
                Scanned copy of list of family members in case of H.U.F.:{" "}
              </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments != null &&
              viewUserDocuments.hufpath !== undefined &&
              viewUserDocuments.hufpath !== "" &&
              viewUserDocuments.hufpath !== null ? (
                <a
                  className="ml-2"
                  target="_blank"
                  href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.hufpath}`}
                  rel="noreferrer"
                >
                  View
                </a>
              ) : (
                ""
              )}
            </CCol>
            <CCol xl={4}>
              <CLabel> Any other related document: </CLabel>
              {viewUserDocuments !== undefined &&
              viewUserDocuments != null &&
              viewUserDocuments.otherdocument !== undefined &&
              viewUserDocuments.otherdocument !== "" &&
              viewUserDocuments.otherdocument !== null ? (
                <a
                  className="ml-2"
                  target="_blank"
                  href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.otherdocument}`}
                  rel="noreferrer"
                >
                  View
                </a>
              ) : (
                ""
              )}
            </CCol>
          </CRow>

          <CButton className="mt-5" color="info" onClick={approveUser}>
            Accept
          </CButton>
          <CButton className="mt-5 ml-2" color="danger" onClick={rejectUser}>
            Reject
          </CButton>
          <CButton
            className="mt-5 ml-2"
            color="success"
            onClick={() => history.goBack()}
          >
            Go Back
          </CButton>
        </CCardHeader>
      )}
    </>
  );
};
export default PendingApprovalView;
